export default "__VITE_ASSET__DZTzMElk__"